/**
 * Created by Kevin Dench on 6/15/2016.
 */
/* @ngInject */
export default function ParameterApiService($resource, __env) {
    return {
        getAllParameters: function (callBack) {
            $resource(
                `${__env.intellidataApiUrl}parameters`
            ).query(callBack);
        },
        getParameter: function (parameterId, callBack) {
            $resource(
                `${__env.intellidataApiUrl}parameters/:id`
            ).get(
                {id: parameterId},
                callBack
            );
        },
        getParametersByDefinitionAndLimiting: function (definitionId, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters/parameters`,
                {id: definitionId, queryRuleLimiting: true}
            ).query(callBack);
        },
        getParametersByDefinitionAndDisplayArea: function (definitionId, displayArea, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters/parameters`,
                {id: definitionId, displayArea: displayArea}
            ).query(callBack);
        },
        getParametersByDefinitionAndAlternateQuery: function (definitionId, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters/parameters`,
                {id: definitionId, includeInAlternateQuery: true}
            ).query(callBack);
        },
        getParameterValues: function (parameterId, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}parameters/:id/values`, {id: parameterId}
            ).query(callBack, callBackError);
        }
    };
}
